<div class="fees-amis ">
  <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs no-bullet rounded-1 align-self-center">
    <li [ngbNavItem]="1">
      <a class="py-md-3 px-md-4" ngbNavLink>Transaction en euros</a>
      <ng-template class="px-5" ngbNavContent>
        <div *ngIf="dep?.tarifs">
          <p><strong>Locaux d’habitation ancien - Mandat de vente
            <br/>(Les honoraires par tranche Vendeur/Acheteur ne se cumulent pas).</strong></p>
          <div class="table-responsive">
            <table class="table table-bordered {{colorText}}">
              <thead>
              <tr>
                <th colspan="2" scope="colgroup"></th>
                <th colspan="2" scope="colgroup" class="text-center">PREMIUM</th>
                <th colspan="2" scope="colgroup" class="text-center">FLASH</th>
                <th colspan="2" scope="colgroup" class="text-center">SIMPLE</th>
              </tr>
              <tr>
                <th scope="col" class="text-center">DE (€)</th>
                <th scope="col" class="text-center">A (€)</th>
                <th scope="col" class="text-center">Vendeur</th>
                <th scope="col" class="text-center">Acheteur</th>
                <th scope="col" class="text-center">Vendeur</th>
                <th scope="col" class="text-center">Acheteur</th>
                <th scope="col" class="text-center">Vendeur</th>
                <th scope="col" class="text-center">Acheteur</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let vente of dep?.tarifs?.vente">
                <td class="text-center text-nowrap">{{vente.prix_mini|numberfr}}</td>
                <td class="text-center text-nowrap" *ngIf="vente.prix_max!=null">{{vente.prix_max|numberfr}}</td>
                <td class="text-center text-nowrap" *ngIf="vente.prix_max==null">+</td>
                <td class="text-center text-nowrap">{{vente.premium_honoraire_vendeur}}</td>
                <td class="text-center text-nowrap">{{vente.premium_honoraire_acheteur}}</td>
                <td class="text-center text-nowrap">{{vente.flash_honoraire_vendeur}}</td>
                <td class="text-center text-nowrap">{{vente.flash_honoraire_acheteur}}</td>
                <td class="text-center text-nowrap">{{vente.simple_honoraire_vendeur}}</td>
                <td class="text-center text-nowrap">{{vente.simple_honoraire_acheteur}}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <p>
            Locaux d'habitation neuf : Selon convention signée avec le promoteur.
            <span *ngIf="dep?.tarifs?.vd_garage"><br/>Garages et parkings :
            {{dep?.tarifs?.vd_garage}}.</span>
            <span *ngIf="dep?.tarifs?.vd_terrain_batir"><br/>Terrains à batir :
            {{dep?.tarifs?.vd_terrain_batir}}.</span>
            <span *ngIf="dep?.tarifs?.vd_terrain_non_constructible"><br/>Terrain non constructible :
            {{dep?.tarifs?.vd_terrain_non_constructible}}.</span>
            <br/>Mandat Access : 3&nbsp;600&nbsp;€&nbsp;TTC.
            <br/>
            <!-- <br/><span>Biens vendus par un professionnel de l’immobilier (Marchand de biens, promoteur, lotisseur, aménageur etc…) : Selon mandat signé avec le professionnel.</span> -->
          </p>
        </div>
      </ng-template>
    </li>
    <li [ngbNavItem]="2">
      <a class="py-md-3 px-md-4" ngbNavLink>Mandats de recherche</a>
      <ng-template ngbNavContent>
        <div *ngIf="dep?.tarifs?.mandat_recherche.length > 0">
          <div class="table-responsive">
            <table class="table table-bordered {{colorText}}">
              <thead>
              <tr>
                <th scope="col" class="text-center">DE (€)</th>
                <th scope="col" class="text-center">A (€)</th>
                <th scope="col" class="text-center">Acheteur</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let mandat_recherche of dep?.tarifs?.mandat_recherche">
                <td class="text-center text-nowrap">{{mandat_recherche.prix_min|numberfr}}</td>
                <td class="text-center text-nowrap" *ngIf="mandat_recherche.prix_max!= null">
                  {{mandat_recherche.prix_max|numberfr}}</td>
                <td class="text-center text-nowrap" *ngIf="mandat_recherche.prix_max == null">+</td>
                <td class="text-center text-nowrap">{{mandat_recherche.honoraire}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ng-template>
    </li>
    <li [ngbNavItem]="3">
      <a class="py-md-3 px-md-4" ngbNavLink>Locaux professionnels</a>
      <ng-template ngbNavContent>
        <p><strong>Locaux commerciaux, pas de porte, droit au bail, ...
          <br/>(Les honoraires par tranche Vendeur/Acheteur ne se cumulent pas).</strong>
        </p>

        <div class="table-responsive">
          <table class="table table-bordered {{colorText}}">
            <thead>
            <tr>
              <th colspan="2" scope="colgroup"></th>
              <th colspan="2" scope="colgroup" class="text-center">PREMIUM</th>
              <th colspan="2" scope="colgroup" class="text-center">FLASH</th>
              <th colspan="2" scope="colgroup" class="text-center">SIMPLE</th>
            </tr>
            <tr>
              <th scope="col" class="text-center">DE (€)</th>
              <th scope="col" class="text-center">A (€)</th>
              <th scope="col" class="text-center">Vendeur</th>
              <th scope="col" class="text-center">Acheteur</th>
              <th scope="col" class="text-center">Vendeur</th>
              <th scope="col" class="text-center">Acheteur</th>
              <th scope="col" class="text-center">Vendeur</th>
              <th scope="col" class="text-center">Acheteur</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let locaux of dep?.tarifs?.locaux">
              <td class="text-center text-nowrap">{{locaux.prix_mini|numberfr}}</td>
              <td class="text-center text-nowrap" *ngIf="locaux.prix_max!=null">{{locaux.prix_max|numberfr}}</td>
              <td class="text-center text-nowrap" *ngIf="locaux.prix_max==null">+</td>
              <td class="text-center text-nowrap">{{locaux.premium_honoraire_vendeur}}</td>
              <td class="text-center text-nowrap">{{locaux.premium_honoraire_acheteur}}</td>
              <td class="text-center text-nowrap">{{locaux.flash_honoraire_vendeur}}</td>
              <td class="text-center text-nowrap">{{locaux.flash_honoraire_acheteur}}</td>
              <td class="text-center text-nowrap">{{locaux.simple_honoraire_vendeur}}</td>
              <td class="text-center text-nowrap">{{locaux.simple_honoraire_acheteur}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </ng-template>
    </li>
    <li [ngbNavItem]="4">
      <a class="py-md-3 px-md-4" ngbNavLink>Fond de commerce</a>
      <ng-template ngbNavContent>
        <div *ngIf="dep?.tarifs?.fond_commerce.length > 0">
          <p><strong>(Les honoraires par tranche Vendeur/Acheteur ne se cumulent pas).</strong></p>

          <div class="table-responsive">
            <table class="table table-bordered {{colorText}}">
              <thead>
              <tr>
                <th colspan="2" scope="colgroup"></th>
                <th colspan="2" scope="colgroup" class="text-center">PREMIUM</th>
                <th colspan="2" scope="colgroup" class="text-center">FLASH</th>
                <th colspan="2" scope="colgroup" class="text-center">SIMPLE</th>
              </tr>
              <tr>
                <th scope="col" class="text-center">DE (€)</th>
                <th scope="col" class="text-center">A (€)</th>
                <th scope="col" class="text-center">Vendeur</th>
                <th scope="col" class="text-center">Acheteur</th>
                <th scope="col" class="text-center">Vendeur</th>
                <th scope="col" class="text-center">Acheteur</th>
                <th scope="col" class="text-center">Vendeur</th>
                <th scope="col" class="text-center">Acheteur</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let fondcommerce of dep?.tarifs?.fond_commerce">
                <td class="text-center text-nowrap">{{fondcommerce.prix_mini|numberfr}}</td>
                <td class="text-center text-nowrap" *ngIf="fondcommerce.prix_max!=null">
                  {{fondcommerce.prix_max|numberfr}}</td>
                <td class="text-center text-nowrap" *ngIf="fondcommerce.prix_max==null">+</td>
                <td class="text-center text-nowrap">{{fondcommerce.premium_honoraire_vendeur}}</td>
                <td class="text-center text-nowrap">{{fondcommerce.premium_honoraire_acheteur}}</td>
                <td class="text-center text-nowrap">{{fondcommerce.flash_honoraire_vendeur}}</td>
                <td class="text-center text-nowrap">{{fondcommerce.flash_honoraire_acheteur}}</td>
                <td class="text-center text-nowrap">{{fondcommerce.simple_honoraire_vendeur}}</td>
                <td class="text-center text-nowrap">{{fondcommerce.simple_honoraire_acheteur}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <p *ngIf="dep?.tarifs?.vd_bail">Résidence de service en exploitation avec bail
          commercial : {{dep?.tarifs?.vd_bail}}.</p>
        <p *ngIf="dep?.tarifs?.cout_estimation_bien">Cout d'estimation d'un bien :
          {{dep?.tarifs?.cout_estimation_bien}}</p>
      </ng-template>
    </li>
    <li [ngbNavItem]="5">
      <a class="py-md-3 px-md-4" ngbNavLink>Location</a>
      <ng-template ngbNavContent>
        <strong>Locaux d’habitation : baux soumis aux dispositions de la loi n° 89-462 du 6 juillet 1989 :</strong>
        <br/>TARIF MAXIMUM TTC EN EUROS *
        <div class="row row-cols-md-2 row-cols-sm-1 py-3">
          <div>
            <p>
              <i>Entremise & négociation.</i>
              <span *ngIf="dep?.tarifs?.lh_entremise"><br/>location nue :  {{dep?.tarifs?.lh_entremise}}.</span>
              <span
                *ngIf="dep?.tarifs?.lh_entremise_meublee"><br/>Location meublée :  {{dep?.tarifs?.lh_entremise_meublee}}
                .</span>
            </p>
            <p>
              <i>Visite, constitution du dossier, rédaction du bail **.</i>
              <span
                *ngIf="dep?.tarifs?.lh_visite_ztres_tendue"><br/>Zone très tendue : {{dep?.tarifs?.lh_visite_ztres_tendue}}
                charge bailleur, {{dep?.tarifs?.lh_visite_ztres_tendue_loc}} charge locataire.</span>
              <span *ngIf="dep?.tarifs?.lh_visite_ztendue"><br/>Zone tendue : {{dep?.tarifs?.lh_visite_ztendue}}
                charge bailleur, {{dep?.tarifs?.lh_visite_ztendue_loc}} charge locataire.</span>
              <span *ngIf="dep?.tarifs?.lh_visite"><br/>Zone non tendue : {{dep?.tarifs?.lh_visite}}
                charge bailleur, {{dep?.tarifs?.lh_visiteloc}} charge locataire.</span>
            </p>
          </div>
          <div class="align-self-md-center mt-4 mt-md-0">
            <p>
              <i>Etat des lieux d’entrée ** (/m² de surface habitable).</i>
              <span *ngIf="dep?.tarifs?.lh_etat_lieux"><br/>{{dep?.tarifs?.lh_etat_lieux}}
                /m² charge bailleur, {{dep?.tarifs?.lh_etat_lieux_loc}}/m² charge locataire.</span>
            </p>
            <p>
              <i>Etat des lieux de sortie ** (/m² de surface habitable).</i>
              <span *ngIf="dep?.tarifs?.lh_etat_lieux_sortie"><br/>{{dep?.tarifs?.lh_etat_lieux_sortie}} charge bailleur.</span>
            </p>
          </div>
        </div>

        <br/><strong>Locaux d’habitation : baux code civil / droit commun :</strong>
        <br/>TARIF MAXIMUM TTC EN EUROS *
          <div class="row row-cols-md-2 row-cols-sm-1 py-3">
          <div>
            <p>
              <i>Entremise, négociation, visite, constitution du dossier & rédaction du bail. **</i>
              <br/><span>7% du loyer annuel charges comprises à la charge du bailleur,
                7% du loyer annuel charges comprises à la charge du locataire.</span>
            </p>
          </div>
          <div class="align-self-md-center mt-4 mt-md-0">
            <p>
              <i>Etat des lieux d’entrée ** (/m² de surface habitable).</i>
              <br/><span>3 € /m² charge bailleur, 3 €/m² charge locataire.</span>
            </p>
            <p>
              <i>Etat des lieux de sortie ** (/m² de surface habitable).</i>
              <br/><span>5 € charge bailleur.</span>
            </p>
          </div>
        </div>

        <br/><strong>Locaux tertiaires (Commerces, bureaux, etc.) :</strong>
        <br/>TARIF MAXIMUM HT EN EUROS
          <div class="row row-cols-md-2 row-cols-sm-1 py-3">
          <div>
            <p>
              <i>Entremise, négociation, visite & constitution du dossier</i>
              <br/><span>10% du loyer triennal hors taxes et hors charges charge locataire.</span>
            </p>
            <p>
              <i>Rédaction du bail **</i>
              <br/><span>400 € charge bailleur, 400 € charge locataire.</span>
            </p>
          </div>
          <div class="align-self-md-center mt-4 mt-md-0">
            <p>
              <i>Etat des lieux d’entrée **</i>
                <br/><span>De 0 à 200 m² : 3,60 € /m² charge bailleur, 3,60 €/m² charge locataire
                <br/>De 201 à 500 m² : 2,90 € /m² charge bailleur, 2,90 €/m² charge locataire
                <br/>A partir de 501 m² : Sur Devis</span>
            </p>
          </div>
        </div>

        <strong>Parkings et Box :</strong>
          <br/>TARIF MAXIMUM TTC EN EUROS *
        <p>
          <span><br/>Entremise, négociation, visite, constitution du dossier & rédaction du bail **</span>
          <span><br/>Forfait 360 € (50% bailleur/50% locataire)<br/><br/></span>
        </p>

        <div>
          <p><strong><i>Simulateur - Savoir si un logement est situé en zone tendue :
            <a class="text-gold-tdm" href="https://www.service-public.fr/simulateur/calcul/zones-tendues" title="Zones tendues" target="_blank">https://www.service-public.fr/simulateur/calcul/zones-tendues</a></i></strong></p>
          <p><strong><i>Quel que soit le mandat, en cas de délégation de mandat, le montant des honoraires applicables
            restent ceux du mandat principal.</i></strong></p>
          <p><strong><i>La dérogation au barème ne doit être qu’exceptionnelle uniquement à la baisse pour des
            affaires particulières liées aux spécificités du marché local et des caractéristiques du bien proposé
            à la vente.
            <br/>* Le taux de TVA appliqué est celui en vigueur au moment de la conclusion de l'acte.
            <br/>** en partenariat avec le cabinet THEMEIS IMMOBILIER RCS 810 816 884 à VERSAILLES.
          </i></strong></p>
        </div>

        <div *ngIf="dep?.tarifs?.locaux_location.length > 0">
          <div class="table-responsive text-white">
            <table class="table table-bordered">
              <thead>
              <tr>
                <th colspan="2" scope="colgroup"></th>
                <th colspan="2" scope="colgroup" class="text-center">PREMIUM</th>
                <th colspan="2" scope="colgroup" class="text-center">FLASH</th>
                <th colspan="2" scope="colgroup" class="text-center">SIMPLE</th>
              </tr>
              <tr>
                <th scope="col" class="text-center">DE (€)</th>
                <th scope="col" class="text-center">A (€)</th>
                <th scope="col" class="text-center">Vendeur</th>
                <th scope="col" class="text-center">Acheteur</th>
                <th scope="col" class="text-center">Vendeur</th>
                <th scope="col" class="text-center">Acheteur</th>
                <th scope="col" class="text-center">Vendeur</th>
                <th scope="col" class="text-center">Acheteur</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let locauxlocation of dep?.tarifs?.locaux_location">
                <td class="text-center text-nowrap">{{locauxlocation.prix_mini|numberfr}}</td>
                <td class="text-center text-nowrap" *ngIf="locauxlocation.prix_max!=null">
                  {{locauxlocation.prix_max|numberfr}}</td>
                <td class="text-center text-nowrap" *ngIf="locauxlocation.prix_max==null">+</td>
                <td class="text-center text-nowrap">{{locauxlocation.premium_honoraire_vendeur}}</td>
                <td class="text-center text-nowrap">{{locauxlocation.premium_honoraire_acheteur}}</td>
                <td class="text-center text-nowrap">{{locauxlocation.flash_honoraire_vendeur}}</td>
                <td class="text-center text-nowrap">{{locauxlocation.flash_honoraire_acheteur}}</td>
                <td class="text-center text-nowrap">{{locauxlocation.simple_honoraire_vendeur}}</td>
                <td class="text-center text-nowrap">{{locauxlocation.simple_honoraire_acheteur}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ng-template>
    </li>
    <li [ngbNavItem]="6">
      <a class="py-md-3 px-md-4" ngbNavLink>Gestion locative</a>
      <ng-template ngbNavContent>
        <p><strong>Honoraires de gestion locative TDM</strong></p>
        <p>Carte G - montant TTC</p>
        <div class="table-responsive">
          <table class="table table-bordered {{colorText}}">
            <thead>
            <tr>
              <th scope="col" class="text-center text-nowrap">&nbsp;</th>
              <th scope="col" class="text-center text-nowrap">Formula ACCESS<br/>6%</th>
              <th scope="col" class="text-center text-nowrap">Formule PREMIUM<br/>7,5%</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="text-nowrap">Quittance, révision, encaissement des loyers</td>
              <td class="text-center text-nowrap">inclus</td>
              <td class="text-center text-nowrap">inclus</td>
            </tr>
            <tr>
              <td class="text-nowrap">Accès Extranet</td>
              <td class="text-center text-nowrap">inclus</td>
              <td class="text-center text-nowrap">inclus</td>
            </tr>
            <tr>
              <td class="text-nowrap">Etablissement des avis d'échéances, quittances de loyers,</td>
              <td class="text-center text-nowrap">inclus</td>
              <td class="text-center text-nowrap">inclus</td>
            </tr>
            <tr>
              <td class="text-nowrap">Suivi des contrats d'assurance habitation et des contrats d'entretiens</td>
              <td class="text-center text-nowrap">inclus</td>
              <td class="text-center text-nowrap">inclus</td>
            </tr>
            <tr>
              <td class="text-nowrap">Relance simple</td>
              <td class="text-center text-nowrap">inclus</td>
              <td class="text-center text-nowrap">inclus</td>
            </tr>
            <tr>
              <td class="text-nowrap">Mise en demeure</td>
              <td class="text-center text-nowrap">12 €</td>
              <td class="text-center text-nowrap">inclus</td>
            </tr>
            <tr>
              <td class="text-nowrap">Relations avec la CAF (établissement des attestations et perception des Allocations Logement)</td>
              <td class="text-center text-nowrap">inclus</td>
              <td class="text-center text-nowrap">inclus</td>
            </tr>
            <tr>
              <td class="text-nowrap">Gestion technique et suivi travaux d'entretien</td>
              <td class="text-center text-nowrap">inclus jusque 300 € *</td>
              <td class="text-center text-nowrap">inclus jusque 1000 € *</td>
            </tr>
            <tr>
              <td class="text-nowrap">Réalisation des régularisations de charges</td>
              <td class="text-center text-nowrap">inclus</td>
              <td class="text-center text-nowrap">inclus</td>
            </tr>
            <tr>
              <td class="text-nowrap">Gestion des dépôts de garanties (encaissements, reversements)</td>
              <td class="text-center text-nowrap">inclus</td>
              <td class="text-center text-nowrap">inclus</td>
            </tr>
            <tr>
              <td class="text-nowrap">Suivi des diagnostics</td>
              <td class="text-center text-nowrap">inclus</td>
              <td class="text-center text-nowrap">inclus</td>
            </tr>
            <tr>
              <td class="text-nowrap">Lien avec le syndic (Paiement des Appels de fonds - reception et Transmission des documents)</td>
              <td class="text-center text-nowrap">inclus</td>
              <td class="text-center text-nowrap">inclus</td>
            </tr>
            <tr>
              <td class="text-nowrap">Aide à la déclaration de revenus fonciers</td>
              <td class="text-center text-nowrap">80 €/an</td>
              <td class="text-center text-nowrap">inclus</td>
            </tr>
            <tr>
              <td class="text-nowrap">Déclaration et suivi de sinistre à la clôture du sinistre</td>
              <td class="text-center text-nowrap">80 €</td>
              <td class="text-center text-nowrap">inclus</td>
            </tr>
            <tr>
              <td class="text-nowrap">Visite sur place en cours d'occupation à la demande à la fourniture du rapport</td>
              <td class="text-center text-nowrap">80 €</td>
              <td class="text-center text-nowrap">inclus</td>
            </tr>
            <tr>
              <td class="text-nowrap">GLI - Garantie loyers impayés</td>
              <td class="text-center text-nowrap">3,20%</td>
              <td class="text-center text-nowrap">3,20%</td>
            </tr>
            <tr>
              <td class="text-nowrap">PNO - Assurance propriétaire non occupant</td>
              <td class="text-center text-nowrap">90 €</td>
              <td class="text-center text-nowrap">90 €</td>
            </tr>
            </tbody>
          </table>
        </div>
        <p>
          *Au-delà de 300 € de facturés :
          <br/>de 301 € à 1000 € : 25 € HT
          <br/>de 1000 € à 3000 € : 50 € HT
          <br/>de 3001 € : 2 % du montant de la facture
        </p>
      </ng-template>
    </li>
    <li [ngbNavItem]="7">
      <a class="py-md-3 px-md-4" ngbNavLink>Viager</a>
      <ng-template ngbNavContent>
        <p><strong>Bareme des honoraires maximum viager*</strong></p>
        <p>LOI N° 70-9 du 2 janvier 1970 - DECRET N° 72-678 du 20 juillet 1972 - LOI n° 2014-366 du 24 mars 2014</p>
        <p>Achat-Vente de Maison, Appartement, Terrain, Garage :</p>

        <div class="table-responsive">
          <table class="table table-bordered {{colorText}}">
            <thead>
              <tr>
                <th colspan="2" scope="colgroup" class="text-center text-nowrap">Honoraires TTC charge Vendeur calculés sur la valeur vénale du bien</th>
              </tr>
            </thead>
            <tbody>
            <tr>
              <td class="text-center text-nowrap">De 0 à 100 000 €</td>
              <td class="text-center text-nowrap">Forfait de 8 500 €</td>
            </tr>
            <tr>
              <td class="text-center text-nowrap">De 10 001 à 150 000 €</td>
              <td class="text-center text-nowrap">9,5 %</td>
            </tr>
            <tr>
              <td class="text-center text-nowrap">De 150 001 € à 200 000 €</td>
              <td class="text-center text-nowrap">8,5 %</td>
            </tr>
            <tr>
              <td class="text-center text-nowrap">De 200 001 € à 300 000 €</td>
              <td class="text-center text-nowrap">7,5 %</td>
            </tr>
            <tr>
              <td class="text-center text-nowrap">De 300 001 € à 400 000 €</td>
              <td class="text-center text-nowrap">7 %</td>
            </tr>
            <tr>
              <td class="text-center text-nowrap">De 400 001 à 800 000 €</td>
              <td class="text-center text-nowrap">6,5 %</td>
            </tr>
            <tr>
              <td class="text-center text-nowrap">Supérieur à 800 001 €</td>
              <td class="text-center text-nowrap">6 % *</td>
            </tr>
            </tbody>
          </table>
        </div>
        * Chaque MANDATAIRE est juridiquement indépendant.
      </ng-template>
    </li>
<!--    <li [ngbNavItem]="8">-->
<!--      <a class="py-md-3 px-md-4" ngbNavLink>LMNP</a>-->
<!--      <ng-template ngbNavContent>-->
<!--        <p><strong>Bareme des honoraires maximum LMNP (location meublée non professionnel)</strong></p>-->
<!--        <div class="table-responsive">-->
<!--          <table class="table table-bordered {{colorText}}">-->
<!--            <thead>-->
<!--            <tr>-->
<!--              <th class="text-center text-nowrap">Prix de vente</th>-->
<!--              <th class="text-center text-nowrap">Pourcentage d'honnoraires</th>-->
<!--            </tr>-->
<!--            </thead>-->
<!--            <tbody>-->
<!--            <tr>-->
<!--              <td class="text-center text-nowrap">De 0 à 100 000 €</td>-->
<!--              <td class="text-center text-nowrap">Forfait de 12 000 €</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--              <td class="text-center text-nowrap">De 10 001 à 150 000 €</td>-->
<!--              <td class="text-center text-nowrap">12 %</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--              <td class="text-center text-nowrap">De 150 001 € à 200 000 €</td>-->
<!--              <td class="text-center text-nowrap">11 %</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--              <td class="text-center text-nowrap">De 200 001 € à 300 000 €</td>-->
<!--              <td class="text-center text-nowrap">10 %</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--              <td class="text-center text-nowrap">De 300 001 € à 600 000 €</td>-->
<!--              <td class="text-center text-nowrap">9 %</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--              <td class="text-center text-nowrap">Supérieur à 600 000 €</td>-->
<!--              <td class="text-center text-nowrap">8 %</td>-->
<!--            </tr>-->
<!--            </tbody>-->
<!--          </table>-->
<!--        </div>-->
<!--      </ng-template>-->
<!--    </li>-->
  </ul>

  <div [ngbNavOutlet]="nav" class="mt-2"></div>

</div>
